Vendd.Scripts.load(function () {
    'use strict';

    var $form = $('.x-share-list'), form;

    if ($form.length < 1) return;

    form = $form.get(0);

    var isCart = $('.cart-region').length > 0 ? true : false;
    var isWishlist = $('.wishlist-region').length > 0 ? true : false;

    var model = null, firstRun = true, slf, linkCode, shareLink;
    var $createListContainer, $createListButton, $shareListContainer;

    //init validation options
    var validationOptions = {
        sendLinkEmail: {
            required: 'sendLinkEmail-required',
            isEmail: 'sendLinkEmail-invalid'
        }
    };

    //init formData
    var formData = {
        sendLinkEmail: "",
        sendLinkName: ""
    };

    form.loading = function loading (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.show = function show () {
        $form.closest('.js-widget-container').show();
    };

    form.hide = function show () {
        $form.closest('.js-widget-container').hide();
    };

    form.init = function init() {
        var html = Vendd.Handlebars.parse("shareListWidget_A", model);
        form.bind(html);

        if (model.IsEmpty) {
            form.hide();
        } else {
            form.show();
        }

        form.reset();

        form.loading(false);
    };

    form.bind = function bind(html) {
        $form.html(html);

        $createListContainer = $('.js-create-list-container', $form);
        $createListButton = $('.js-create-share-list', $form);
        $shareListContainer = $('.js-share-list-container', $form);

        form.loading(false);

        if (firstRun) {
            $form.removeClass('x-initializing');
            firstRun = false;
        }
    };

    form.bindShare = function bindShare() {
        $createListContainer.addClass('hidden');
        $shareListContainer.removeClass('hidden');

        //generate share link based in link code
        shareLink = window.location.origin + '/page/sharedlist/?sharedList=' + linkCode;
        $('input[name="link"]', $form).val(shareLink);

        //init validation for send link
        $form.validationEngine(validationOptions);
        slf = $form.data('validationEngine');

        form.loading(false);
    };

    form.reset = function reset() {
        $('input[name="shareListName"]', $form).val("");
        $('input[name="link"]', $form).val("");
        $('input[name="sendLinkEmail"]', $form).val("");
        $('input[name="sendLinkName"]', $form).val("");

        $('.js-error', $form).removeClass('visible');
        $('.js-success', $form).removeClass('visible');
    };

    form.createShareList = function () {
        form.loading(true);

        var shareListName = $('input[name="shareListName"]', $form).val();

        if (isCart) {
            Vendd.MessageBus.publishAsync(form, new Vendd.SharedLists.Messages.ShareCart(shareListName));
        } else if (isWishlist) {
            var wishlistId = $('.x-wishlist ul').data('list-id');
            Vendd.MessageBus.publishAsync(form, new Vendd.SharedLists.Messages.ShareWishList(wishlistId, shareListName));
        }      
    };

    form.copyLinkSuccess = function copyLinkSuccess() {
        $('.copy-link-container .js-success').addClass('visible');
        setTimeout(function () {
            $('.copy-link-container .js-success').removeClass('visible');
        }, 3000);
    };

    form.copyLinkFailure = function copyLinkFailure() {
        $('.copy-link-container .js-error').addClass('visible');
        setTimeout(function () {
            $('.copy-link-container .js-error').removeClass('visible');
        }, 3000);
    };

    form.sendListSuccess = function sendListSuccess() {
        $('.send-link-container .js-content').hide();
        $('.send-link-container .js-success').addClass('visible');

        //reset inputs
        $('input[name="sendLinkEmail"]', $form).val("");
        $('input[name="sendLinkName"]', $form).val("");
    };

    form.sendListFailure = function sendListFailure() {
        $('.send-link-container .js-content').hide();
        $('.send-link-container .js-error').addClass('visible');

        //reset inputs
        $('input[name="sendLinkEmail"]', $form).val("");
        $('input[name="sendLinkName"]', $form).val("");
    };

    $form.on('keyup', 'input[name="shareListName"]', function (e) {

        var $this = $(this);

        if ($this.val().length > 0) {
            $createListButton.prop('disabled', false);
        } else {
            $createListButton.prop('disabled', true);
        }
    });

    $form.on('keyup', 'input[name="sendLinkEmail"], input[name="sendLinkName"]', function (e) {

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();

        slf.validate(fieldName);
    });

    $form.on('click', '.js-create-share-list', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($createListButton.prop('disabled') == true)
            return;

        form.createShareList();
    });

    $form.on('click', '.js-copy-link', function (e) {
        e.preventDefault();
        e.stopPropagation();

        navigator.clipboard.writeText(shareLink).then(function () {
            form.copyLinkSuccess();
        }, function (err) {
            form.copyLinkFailure();
        });
    });

    $form.on('click', '.js-send-link', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var sendLinkValidation = slf.validate();

        if (sendLinkValidation) {
            Vendd.MessageBus.publishAsync(form, new Vendd.SharedLists.Messages.SendList(linkCode, formData.sendLinkName, formData.sendLinkEmail));
        }      
    });

    Vendd.MessageBus.subscribe(Vendd.SharedLists.Messages.ShareCartSuccess, form, function (envelope) {
        var data = JSON.parse(envelope.message.data.data);
        linkCode = data.linkCode;

        if (linkCode.length > 0) {
            form.bindShare();
        } else {
            form.loading(false);
        } 
    });

    Vendd.MessageBus.subscribe(Vendd.SharedLists.Messages.ShareWishListSuccess, form, function (envelope) {
        var data = JSON.parse(envelope.message.data.data);
        linkCode = data.linkCode;

        if (linkCode.length > 0) {
            form.bindShare();
        } else {
            form.loading(false);
        }
    });

    Vendd.MessageBus.subscribe(Vendd.SharedLists.Messages.SendListSuccess, form, function (envelope) {
        if (envelope.message.data.success === true) {
            form.sendListSuccess();
        } else {
            form.sendListFailure();
        }
    }); 

    Vendd.MessageBus.subscribe(Vendd.SharedLists.Messages.SendListFailure, form, form.sendListFailure);

    if (isCart) {
        Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, form, function (envelope) {
            model = envelope.message.data.Cart;
            form.init();
        });
    } else if (isWishlist) {
        Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, form, function (envelope) {
            model = envelope.message.data;
            form.init();
        });
    }

});